import User from "./user";
import Sms from "./sms";
import PublicApi from "./public-api";
import Msg from "./message";
import Email from "./email";
import Application from "./application";
import { replaceAll } from "../utils";
import TplVerify from "../templates/email-verify-address";
import TplRegister from "../templates/email-registration";
import ISystemMsgSubstitution from "../interface/system-msg-substitution";
import Global from "../global";
import ServiceName from "../enum/service-name";
import Message from "../enum/message";

class SystemMsgSingleton {

    /* Public Methods */

    public async emailRegistration(instance: string): Promise<void> {
        const body: string = this.buildTemplate(TplRegister, [
            { subst: '[REGISTRATION_USERNAME]', value: User.getName() },
            { subst: '[REGISTRATION_APPNAME]', value: Application.getName() as string },
            { subst: '[REGISTRATION_APPID]', value: Application.getId() },
            { subst: '[REGISTRATION_INSTANCE]', value: instance },
            { subst: '[REGISTRATION_ORIGIN]', value: location.origin },
            { subst: '[REGISTRATION_TIMEZONE]', value: Intl.DateTimeFormat().resolvedOptions().timeZone },
            { subst: '[REGISTRATION_DATETIME]', value: (new Date()).toLocaleString() },
            { subst: '[REGISTRATION_USERAGENT]', value: navigator.userAgent }
        ]);
        await Email.sendSingle(body, Global.SYS_EMAIL_REG_SUBJ, Global.SYS_EMAIL_REG_RECIPIENT, Global.SYS_EMAIL_REG_CC, Global.SYS_MSG_SENDER_PRIVATE);
    }

    public async emailAddressVerification(address: string): Promise<void> {
        const link: string = PublicApi.getVerificationAddress(address, ServiceName.Email);
        const subject: string = Msg.get(Message.verifyemailtitle);
        const body: string = this.buildTemplate(TplVerify, [
            { subst: '[VERIFICATION_TITLE]', value: Msg.get(Message.verifyemailtitle) },
            { subst: '[VERIFICATION_TEXT]', value: Msg.get(Message.verifyemailtext) },
            { subst: '[VERIFICATION_SUBMIT]', value: Msg.get(Message.verifyemailsubmit) },
            { subst: '[VERIFICATION_LINK]', value: link },
        ]);
        await Email.sendSingle(body, subject, [address], [], Global.SYS_MSG_SENDER_PUBLIC);
    }

    public async phoneAddressVerification(address: string): Promise<void> {
        const link: string = await PublicApi.getVerificationAddressShorten(address, ServiceName.Sms);
        const msg: string = this.buildTemplate(Msg.get(Message.verifyphonetext), [
            { subst: '[VERIFICATION_LINK]', value: link },
        ]);
        await Sms.sendSingle(Global.SYS_MSG_SENDER_PUBLIC, address, msg);
    }

    /* Private Methods */

    private buildTemplate(tpl: string, subs: ISystemMsgSubstitution[]): string {
        let result: string = `${tpl}`;
        subs.forEach((s: ISystemMsgSubstitution) => {
            result = replaceAll(result, s.subst, this.prepareString(s.value));
        });
        return result;
    }

    private prepareString(origin: string): string {
        return replaceAll(origin, '\n', '<br/>');
    }

}

const SystemMsg = new SystemMsgSingleton();

export default SystemMsg;